export abstract class BaseModel{
    id:any;
    constructor(id){
        this.id = id;
    }
}